import React from 'react'

const MenuTitle = ({title}) => {
  return (
    <div className='f-footer-text-bold'>{title}</div>
  )
}

export default MenuTitle
